import './LiksIconButton.css';

export type LiksIconButtonVariant =
  'on-light' | 'on-dark' | 'outlined' | 'outlined-on-dark';

export type LiksIconButtonProps = {
  variant?: LiksIconButtonVariant;
  children: React.ReactNode;
  className?: string;
} & React.ComponentPropsWithoutRef<'button'>;

export function LiksIconButton({
  variant = 'on-light',
  children,
  className,
  type = 'button',
  ...buttonProps
}: LiksIconButtonProps) {
  const classNames = [
    'liks-icon-button',
    `liks-icon-button--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classNames} {...buttonProps}>
      {children}
    </button>
  );
}
